import { inRange } from 'lodash';

import { Diff, StoreOpenStatus } from '../../types';

export const getStoreOpenStatusFromDiff = (diff: Diff): StoreOpenStatus => {
	// if the current time is 30 minutes or less than -15 minutes and more than 0 minutes
	if (inRange(diff.open, -30, -15)) return 'NOT_OPEN_YET';

	// before the store's open time (-15 <= diff.open < 0)
	if (inRange(diff.open, -15, 0)) return 'OPENING_SOON';

	// we can now assume that diff.open >= 0 and that the current time is at or
	// after the store's open time

	// if the current time is 30 minutes or less than and more than 0 minutes
	// before the store's close time (-30 <= diff.close < 0)
	if (inRange(diff.close, -30, 0)) return 'CLOSING_SOON';

	// if the current time is more than 30 minutes before the store's close time
	if (diff.open >= 0 && diff.close < 0) return 'OPEN';

	// we can now assume that diff.close >= 0 and that the current time is at or
	// after the store's close time
	return 'CLOSED';
};
